"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenService = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const http_1 = require("@angular/http");
const platform_browser_1 = require("@angular/platform-browser");
//INTERNAL BITS
const ng2_cookies_1 = require("ng2-cookies");
const bootstrap_1 = require("angular2-modal/plugins/bootstrap");
let TokenService = class TokenService {
    constructor(document, _http, _cookieService, _modal) {
        this.document = document;
        this._cookieService = _cookieService;
        this._modal = _modal;
        this.http = _http;
    }
    createAuthorizationHeader(headers) {
        headers.append("Authorization", "Bearer " + this.token);
    }
    getCustomHeader(url, hAdd) {
        let headers = new http_1.Headers();
        this.createAuthorizationHeader(headers);
        if (hAdd && hAdd.key != "")
            headers.append(hAdd["key"], hAdd["value"]);
        return this.http.get(url, {
            headers: headers,
        });
    }
    get(url) {
        let headers = new http_1.Headers();
        this.createAuthorizationHeader(headers);
        return this.http.get(url, {
            headers: headers,
        });
    }
    post(url, data = {}) {
        let headers = new http_1.Headers();
        this.createAuthorizationHeader(headers);
        return this.http.post(url, data, {
            headers: headers,
        });
    }
    postCustomHeader(url, data = {}, hAdd = {}) {
        let headers = new http_1.Headers();
        this.createAuthorizationHeader(headers);
        if (hAdd && hAdd.key && Object.keys(hAdd.key).length > 0)
            headers.append(hAdd["key"], hAdd["value"]);
        return this.http.post(url, data, {
            headers: headers,
        });
    }
    put(url, data = {}) {
        let headers = new http_1.Headers();
        this.createAuthorizationHeader(headers);
        return this.http.put(url, data, {
            headers: headers,
        });
    }
    patch(url, data = {}) {
        let headers = new http_1.Headers();
        this.createAuthorizationHeader(headers);
        return this.http.patch(url, data, {
            headers: headers,
        });
    }
    delete(url) {
        let headers = new http_1.Headers();
        this.createAuthorizationHeader(headers);
        return this.http.delete(url, {
            headers: headers,
        });
    }
    createNewAuthHeaders() {
        let headers = new http_1.Headers();
        this.createAuthorizationHeader(headers);
        return headers;
    }
    setToken(token) {
        this._cookieService.set("authToken", token);
        this.token = token;
    }
    verifySession() {
        if (this.token) {
            return true;
        }
        else {
            return false;
        }
    }
    destroySession() {
        this._cookieService.delete("authToken");
        this.token = null;
        return void 0;
    }
    verifyCookieToken() {
        let cookieToken = this._cookieService.get("authToken");
        if (cookieToken) {
            //verify the found cookieToken is valid;
            return this.isValidAuthToken(cookieToken);
        }
        return Promise.reject(new Error("No Cookie authToken Found"));
    }
    isValidAuthToken(token) {
        return this.post("/verify", { token })
            .toPromise()
            .then((res) => res.json())
            .catch((err) => err.message);
    }
    externalRedirect(url, openInNewWindow = true) {
        if (openInNewWindow) {
            let redirectWindow = window.open("", "_blank");
            if (redirectWindow === null) {
                //unable to open or need permission
                this.showBrowserAlertsHelp(`
         <p>Please make sure to allow <b>window pop-ups</b> for this page on your Browser preferences, so that we can process your request.</p>
         <p>Depending on your Browser. You can do this by clicking the Browser alert near the navigation bar and clicking <b>Always allow pop-ups</b>.
        `);
            }
            else {
                // update location href
                redirectWindow.location.href = url;
                redirectWindow.focus();
            }
        }
        else
            this.document.location.assign(url);
    }
    showBrowserAlertsHelp(msg) {
        this._modal
            .alert()
            .size("lg")
            .showClose(true)
            .title("Verify Browser Preferences")
            .body(msg)
            .open();
    }
};
exports.TokenService = TokenService;
exports.TokenService = TokenService = __decorate([
    (0, core_1.Injectable)(),
    __param(0, (0, core_1.Inject)(platform_browser_1.DOCUMENT)),
    __metadata("design:paramtypes", [Object, http_1.Http,
        ng2_cookies_1.CookieService,
        bootstrap_1.Modal])
], TokenService);
//# sourceMappingURL=token.service.js.map